import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
export function LanguageToggle() {
  const {
    lang,
    setLang,
    t
  } = useLanguage();
  return <div className="flex items-center rounded-sm border border-gold/30 p-0.5" role="group" aria-label={t.header.langSwitch} data-id="element-230" data-mp="2k96gm162z6xb">
      {(['es', 'en'] as const).map(option => {
      const active = lang === option;
      return <button key={option} type="button" onClick={() => setLang(option)} aria-pressed={active} className={`whitespace-nowrap px-3 py-2 font-display text-[11px] font-semibold uppercase tracking-wider transition-colors duration-150 ease-out sm:text-xs ${active ? 'bg-gold text-ink' : 'text-cream/65 hover:text-gold-light'}`} data-id="element-231" data-mp="25j7l665wu9lj">
            {option === 'es' ? 'Español' : 'English'}
          </button>;
    })}
    </div>;
}